var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeo4J(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.337341 0 0 .337341 3.403432 -24.014634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.8 157.35c0 43.78-35.485 79.265-79.265 79.265S1.27 201.13 1.27 157.35s35.485-79.265 79.265-79.265c43.78-.04 79.266 35.485 79.266 79.265",
    fill: "#008dc2"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    x: 1.075,
    y: 17.397
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.363 167.18c0 3.495-2.842 6.337-6.337 6.337s-6.337-2.842-6.337-6.337 2.842-6.337 6.337-6.337c3.496-.038 6.337 2.804 6.337 6.337m8.68 16.514c0 3.495-2.842 6.337-6.337 6.337s-6.337-2.842-6.337-6.337 2.842-6.337 6.337-6.337c3.495-.038 6.337 2.804 6.337 6.337"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.423 193.14c0 3.495-2.842 6.337-6.337 6.337s-6.337-2.842-6.337-6.337 2.842-6.337 6.337-6.337 6.337 2.843 6.337 6.337"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C",
    x: -21.89,
    y: -110.027
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.345 90.9c0 3.495-2.842 6.337-6.337 6.337S66.67 94.405 66.67 90.9s2.842-6.337 6.337-6.337 6.337 2.843 6.337 6.337"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#68b346",
    stroke: "#fff",
    strokeWidth: 3.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 124.277,
    cy: 138.454,
    r: 42.244
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.403,
    cy: 224.594,
    r: 34.563
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.946,
    cy: 95.98,
    r: 23.042
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "B",
    d: "M36.41 131.35c0 3.495-2.842 6.337-6.337 6.337s-6.337-2.842-6.337-6.337 2.842-6.337 6.337-6.337a6.32 6.32 0 0 1 6.337 6.337"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C",
    d: "M117.902 206.775c0 3.495-2.842 6.337-6.337 6.337s-6.337-2.842-6.337-6.337 2.842-6.337 6.337-6.337 6.337 2.842 6.337 6.337"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeo4J);
export default __webpack_public_path__ + "static/media/neo4j.a3fe25cc4e85c7438e6f604b87522652.svg";
export { ForwardRef as ReactComponent };